import { slice } from "./xhr-hook-array";
import { mergeObjects, fakeEvent } from "./xhr-hook-events";

//tiny event emitter
export const EventEmitter = function (nodeStyle: any) {
  //private
  let events: any = {};
  const listeners = (event: any) => events[event] || [];

  //public
  const emitter: any = {};

  emitter.addEventListener = function (event: any, callback: any, i: any) {
    events[event] = listeners(event);
    if (events[event].indexOf(callback) >= 0) {
      return;
    }
    i = i === undefined ? events[event].length : i;
    events[event].splice(i, 0, callback);
  };

  emitter.removeEventListener = function (event: any, callback: any) {
    //remove all
    if (event === undefined) {
      events = {};
      return;
    }
    //remove all of type event
    if (callback === undefined) {
      events[event] = [];
    }
    //remove particular handler
    const i = listeners(event).indexOf(callback);
    if (i === -1) {
      return;
    }
    listeners(event).splice(i, 1);
  };

  emitter.dispatchEvent = function () {
    const args = (<any>slice)(arguments);
    const event = args.shift();

    if (!nodeStyle) {
      args[0] = mergeObjects(args[0], fakeEvent(event));
      Object.defineProperty(args[0], "target", {
        writable: false,
        value: this
      });
    }

    const legacylistener = emitter[`on${event}`];
    if (legacylistener) {
      legacylistener.apply(emitter, args);
    }

    const iterable = listeners(event).concat(listeners("*"));
    for (let i = 0; i < iterable.length; i++) {
      const listener = iterable[i];
      listener.apply(emitter, args);
    }
  };

  emitter._has = (event: any) => !!(events[event] || emitter[`on${event}`]);

  //add extra aliases
  if (nodeStyle) {
    emitter.listeners = (event: any) => (<any>slice)(listeners(event));
    emitter.on = emitter.addEventListener;
    emitter.off = emitter.removeEventListener;
    emitter.fire = emitter.dispatchEvent;
    emitter.once = function (e: any, fn: any) {
      var fire = function () {
        emitter.off(e, fire);
        return fn.apply(null, arguments);
      };
      return emitter.on(e, fire);
    };
    emitter.destroy = () => (events = {});
  }

  return emitter;
};
